import { Prospect } from "./prospect";
import { Staff } from "./Staff";

export class Suivi {
    suiviId: number;
    commentaire: string;
    title: string;
    contact: string;
    commercial: string;
    projet: string;

    possibilteSignature: string = 'moyenne';
    allDay: boolean = false;
    agenda: boolean;
    sticky: boolean = false;
    archivee: boolean = false;

    start: any;
    prospect: Prospect;
    utilisateurs: Staff;
    idMail: number;
    color: string
    x: number

    y: number
}
/*
    id: number;
    title: string;
    start: string;
    end: string;
    
    userName:string;
    detail:string;
    prospect:Prospect;
    allDay: boolean;
*/